/**
 * Login page identity toggle (email <-> phone).
 *
 * Lets the customer switch the single login username field between an email
 * input and a phone-number input with a country-code selector (intl-tel-input),
 * so they don't have to type the dialing code (e.g. +855) manually.
 *
 * The real username field submitted to the backend is always `email`; when the
 * phone mode is active we mirror the full international phone number (kept up to
 * date by the shared phone-number-script) into that `email` field.
 */
(function () {
    function initLoginIdentity() {
        var container = document.getElementById('login-identity');

        if (!container) {
            return;
        }

        var emailInput = container.querySelector('.js-login-email');
        var phoneDisplay = container.querySelector('.js-login-phone');
        var phoneHidden = container.querySelector('input[name="login_phone"]');
        var emailItem = container.querySelector('.login-identity__item--email');
        var phoneItem = container.querySelector('.login-identity__item--phone');
        var switchBtn = container.querySelector('.js-login-switch');

        if (!emailInput || !switchBtn || !emailItem || !phoneItem) {
            return;
        }

        function setSwitchLabel(text) {
            if (!text) {
                return;
            }

            switchBtn.setAttribute('title', text);
            switchBtn.setAttribute('aria-label', text);
        }

        function syncPhoneToEmail() {
            if (container.getAttribute('data-mode') !== 'phone') {
                return;
            }

            if (phoneHidden && phoneHidden.value) {
                emailInput.value = phoneHidden.value;
            } else if (phoneDisplay) {
                emailInput.value = phoneDisplay.value || '';
            }
        }

        function setMode(mode) {
            container.setAttribute('data-mode', mode);

            if (mode === 'phone') {
                emailItem.classList.add('d-none');
                phoneItem.classList.remove('d-none');
                // Switch to text so the browser does not run e-mail validation on the phone value.
                emailInput.type = 'text';
                setSwitchLabel(switchBtn.getAttribute('data-label-email'));
                syncPhoneToEmail();
            } else {
                phoneItem.classList.add('d-none');
                emailItem.classList.remove('d-none');
                emailInput.type = 'email';
                setSwitchLabel(switchBtn.getAttribute('data-label-phone'));
            }
        }

        switchBtn.addEventListener('click', function () {
            var next = container.getAttribute('data-mode') === 'phone' ? 'email' : 'phone';

            emailInput.value = '';

            if (next === 'email' && phoneDisplay) {
                phoneDisplay.value = '';

                if (phoneHidden) {
                    phoneHidden.value = '';
                }
            }

            setMode(next);

            if (next === 'phone' && phoneDisplay) {
                phoneDisplay.focus();
            } else {
                emailInput.focus();
            }
        });

        if (phoneDisplay) {
            ['input', 'blur', 'change', 'keyup'].forEach(function (evt) {
                phoneDisplay.addEventListener(evt, syncPhoneToEmail);
            });
        }

        if (phoneHidden) {
            phoneHidden.addEventListener('change', syncPhoneToEmail);
        }

        var form = container.closest('form');

        if (form) {
            form.addEventListener('submit', syncPhoneToEmail);
        }

        setMode(container.getAttribute('data-mode') || 'email');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLoginIdentity);
    } else {
        initLoginIdentity();
    }
})();
